import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=b905a908&scoped=true"
import script from "./Achievement.vue?vue&type=script&lang=js"
export * from "./Achievement.vue?vue&type=script&lang=js"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=b905a908&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b905a908",
  null
  
)

export default component.exports